import React from "react";

import * as firebase from "firebase";

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";

import Button from "components/CustomButtons/Button.jsx";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import NavPills from "components/NavPills/NavPills.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Switch from "@material-ui/core/Switch";
import TabAudio from "components/BivConfigurationProctoring/TabAudio/TabAudio.jsx";
import TabAmbiente from "components/BivConfigurationProctoring/TabAmbiente/TabAmbiente.jsx";
import TabGeneral from "components/BivConfigurationProctoring/TabGeneral/TabGeneral.jsx";
import TabImagen from "components/BivConfigurationProctoring/TabImagen/TabImagen.jsx";
import TabValidacion from "components/BivConfigurationProctoring/TabValidacion/TabValidacion.jsx";

import CircularProgress from "@material-ui/core/CircularProgress";

import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

import _ from "lodash";
import { Prompt } from "react-router-dom";

import HistoryIcon from "@mui/icons-material/History";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
import { pink } from "@mui/material/colors";
import ActionInformation from "./ActionInformation/ActionInformationFn";

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';

import moment from "moment"

import { Paper } from "@material-ui/core";


const languages = require("../../assets/translate/translate_proctoringControl.json");
let lang = localStorage.lang ? localStorage.lang : "es";

const GreenSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#00BFFF",
    "&:hover": {
      backgroundColor: alpha(pink[600], theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#00BFFF",
  },
}));



class BivConfigurationProctoring extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
      loading: true,
      change: false,
      confOrig: [],
      conf: [],
      viewActions: false,
      activeUsers: null,

      searchStartDate: moment()
        .subtract(15, "days")
        .format("YYYY-MM-DD"),
      searchEndDate: moment().format("YYYY-MM-DD"),
    };



    this.intervalActivity = null
  }

  componentWillUnmount() {
    clearInterval(this.intervalActivity)
  }




  componentDidMount() {
    const userdata = JSON.parse(localStorage.rol)
    //let loading = this.state
    //loading = true
    // TODO : add common/ when morin upload new backend
    this.intervalActivity = setInterval(() => {
      var myHeaders = new Headers();
      let _token = localStorage.getItem("fb_jwt");
      myHeaders.append("Authorization", "Bearer " + _token);
      var formdata = new FormData();
      formdata.append("type", "A");
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      fetch(global.Direction_Back_panel + "/panel/activeUserConfig", requestOptions)
        .then((response) => response.text())
        .then((result) => {
        })
        .catch((error) => console.log("error", error));
    }, 20000)
    const processUsers = (users) => {
      const nowTime = Date.now()
      for (let i in users) {
        let user = users[i]
        if (user.time < nowTime - 60000 || userdata.authorities.id == i) {
          delete users[i]
        }
      }

      this.setState({ activeUsers: Object.values(users) })
    }

    firebase.database().ref("/activeUsers/configurationsA").on('value', (snapshot) => {
      processUsers(snapshot.val())
    },(err)=>{
      console.log('fb',err)
    })

    let route = (((global.common_config)) ? 'common/' : '') + 'configurationsA';
    firebase.database().ref(route).once('value', (x) => {
      let xval = x.val()
      if (xval) {

        //let _confOrig = x.val()
        //let _conf = x.val()
        let _confOrig = JSON.parse(JSON.stringify(xval))
        let _conf = JSON.parse(JSON.stringify(xval))

        //Control Bateria
        //let newConfbl = { a: true, c: 1, ip: 1, bl: 1, t: {  p: 1, v: 1} }
        //_conf['bl'] = newConfbl

        //Control Almacenamiento
        //let newConfcs = { a: true, c: 1, ip: 1, mb: 1, t: {  p: 1, v: 1} }
        //_conf['cs'] = newConfcs

        //Control Monitoreo
        //let newConfmc = { a: true, c: 1, ip: 1, t: {  p: 1, v: 1} }
        //_conf['mc'] = newConfmc

        //Control Maquinas Virtuales
        //let newConfvm = { a: true, c: 1, ip: 1, t: {  p: 1, v: 1} }
        //_conf['vm'] = newConfvm

        //Control Microfono
        //let newConfmsc = { a: true, c: 1, ip: 1, t: {  p: 1, v: 1} }
        //_conf['msc'] = newConfmsc

        //Control Procesos
        //let newConfpc = { a: false, c: 1, ip: 1, t: {  p: 1, v: 1}, p: [{"pname":"jing.exe"},{"pname":"jing.exe*32"},{"pname":"jing.exe *32"},{"pname":"Jing.exe"},{"pname":"Jing.exe*32"},{"pname":"Jing.exe *32"},{"pname":"camtasia.exe"},{"pname":"camtasia.exe*32"},{"pname":"camtasia.exe *32"},{"pname":"CamtasiaStudio.exe"},{"pname":"CamtasiaStudio.exe*32"},{"pname":"CamtasiaStudio.exe *32"},{"pname":"CamRecorder.exe"},{"pname":"CamRecorder.exe*32"},{"pname":"CamRecorder.exe *32"},{"pname":"Recorder.exe"},{"pname":"Recorder.exe*32"},{"pname":"Recorder.exe *32"},{"pname":"Dxtory.exe"},{"pname":"Dxtory.exe*32"},{"pname":"Dxtory.exe *32"},{"pname":"Dxtory64.exe"},{"pname":"Dxtory64.exe*32"},{"pname":"Dxtory64.exe *32"},{"pname":"fraps.exe"},{"pname":"fraps.exe*32"},{"pname":"fraps.exe *32"},{"pname":"fraps64.dat"},{"pname":"ScreenCapturer.exe"},{"pname":"ScreenCapturer.exe*32"},{"pname":"ScreenCapturer.exe *32"},{"pname":"HyCam2.exe"},{"pname":"HyCam2.exe*32"},{"pname":"HyCam2.exe *32"},{"pname":"Snagit32.exe"},{"pname":"Snagit32.exe*32"},{"pname":"Snagit32.exe *32"},{"pname":"screen-recorder.exe"},{"pname":"screen-recorder*32.exe"},{"pname":"screen-recorder.exe *32"},{"pname":"Apowersoft Free Screen Recorder.exe"},{"pname":"Screencast-O-Matic.exe"},{"pname":"Wink.exe"},{"pname":"FlashBack Recorder.exe"},{"pname":"Skype.exe"},{"pname":"TeamViewer.exe"},{"pname":"LMIIgnition.exe"},{"pname":"LogMeInSystray.exe"},{"pname":"WINWORD.EXE"},{"pname":"EXCEL.EXE"},{"pname":"POWERPNT.EXE"},{"pname":"notepad.exe"},{"pname":"notepad++.exe"},{"pname":"firefox.exe"},{"pname":"opera.exe"},{"pname":"chrome.exe"},{"pname":"iexplore.exe"},{"pname":"AcroRd32.exe"},{"pname":"preme.exe"},{"pname":"premeeng.exe"},{"pname":"PremeInterface.exe"},{"pname":"Ares.exe"},{"pname":"Ares.exe*32"},{"pname":"Ares.exe *32"},{"pname":"iTunes"},{"pname":"iTunes.exe"},{"pname":"iTunesHelper"},{"pname":"iTunesHelper.exe"},{"pname":"preme.exe"},{"pname":"premeeng.exe"},{"pname":"PremeInterface.exe"},{"pname":"LightScreen.exe"},{"pname":"LightScreen.exe*32"},{"pname":"LightScreen.exe *32"},{"pname":"rutserv.exe"},{"pname":"rutserv.exe*32"},{"pname":"rfusclient.exe"},{"pname":"rfusclient.exe*32"},{"pname":"UVNC_Launch.exe"},{"pname":"UVNC_Launch.exe*32"},{"pname":"repeater.exe"},{"pname":"repeater.exe*32"},{"pname":"vncviewer.exe"},{"pname":"vncviewer.exe*32"},{"pname":"winvnc.exe"},{"pname":"winvnc.exe*32"},{"pname":"uvnc2me.exe"},{"pname":"uvnc2me.exe*32"},{"pname":"uvnc_screenrecorder.exe"},{"pname":"uvnc_screenrecorder.exe*32"},{"pname":"AeroAdmin.Exe"},{"pname":"AeroAdmin.Exe*32"},{"pname":"mstsc.exe"},{"pname":"mstsc.exe*32"},{"pname":"AnyDesk.exe"},{"pname":"AnyDesk.exe*32"},{"pname":"RPCSuite.exe"},{"pname":"RPCSuite.exe*32"},{"pname":"RPCPrintServer.exe"},{"pname":"RPCPrintServer.exe*32"},{"pname":"ROMFUSClient.exe"},{"pname":"ROMFUSClient.exe*32"},{"pname":"ROMServer.exe"},{"pname":"ROMServer.exe*32"},{"pname":"ROMViewer.exe"},{"pname":"ROMViewer.exe*32"},{"pname":"desktopnow.exe"},{"pname":"desktopnow.exe*32"},{"pname":"beamyourscreen-host.exe"},{"pname":"beamyourscreen-host.exe*32"},{"pname":"Zoho URSService.exe"},{"pname":"Zoho URSService.exe*32"},{"pname":"CloudRaService.exe"},{"pname":"CloudRaService.exe*32"},{"pname":"CloudBerry Remote Assistant.exe"},{"pname":"CloudBerry Remote Assistant.exe*32"},{"pname":"vmware.exe"},{"pname":"vmware.exe*32"},{"pname":"vmplayer.exe"},{"pname":"vmplayer.exe*32"},{"pname":"vmnat.exe"},{"pname":"vmnat.exe*32"},{"pname":"vmnetdhcp.exe"},{"pname":"vmnetdhcp.exe*32"},{"pname":"vmware-usbarbitrator64.exe"},{"pname":"vmware-usbarbitrator64.exe*32"},{"pname":"VGAuthService.exe"},{"pname":"VGAuthService.exe*32"},{"pname":"vmware-authd.exe"},{"pname":"vmware-authd.exe*32"},{"pname":"vmtoolsd.exe"},{"pname":"vmtoolsd.exe*32"},{"pname":"vmacthlp.exe"},{"pname":"vmacthlp.exe*32"},{"pname":"VirtualBox.exe"},{"pname":"VirtualBox.exe*32"},{"pname":"VBoxSVC.exe"},{"pname":"VBoxSVC.exe*32"},{"pname":"Lightshot.exe"},{"pname":"Lightshot.exe*32"},{"pname":"Lightshot.exe *32"},{"pname":"FSCapture.exe"},{"pname":"FSCapture.exe*32"},{"pname":"FSCapture.exe *32"},{"pname":"SnippingTool.exe"},{"pname":"SnippingTool.exe*32"},{"pname":"SnippingTool.exe *32"},{"pname":"Greenshot.exe"},{"pname":"Greenshot.exe*32"},{"pname":"Greenshot.exe *32"},{"pname":"AutoScreenshotCapture.exe"},{"pname":"AutoScreenshotCapture.exe*32"},{"pname":"AutoScreenshotCapture.exe *32"},{"pname":"AutoScreenCap.exe"},{"pname":"AutoScreenCap.exe*32"},{"pname":"AutoScreenCap.exe *32"},{"pname":"ShareX.exe"},{"pname":"ShareX.exe*32"},{"pname":"ShareX.exe *32"},{"pname":"picpick.exe"},{"pname":"picpick.exe*32"},{"pname":"picpick.exe *32"},{"pname":"PrtScr.exe"},{"pname":"PrtScr.exe*32"},{"pname":"PrtScr.exe *32"},{"pname":"PhotosApp.exe"},{"pname":"PhotosApp.exe*32"},{"pname":"PhotosApp.exe *32"},{"pname":"numbers.exe"},{"pname":"numbers.exe*32"},{"pname":"numbers.exe *32"},{"pname":"notepad.exe"},{"pname":"notepad.exe*32"},{"pname":"notepad.exe *32"},{"pname":"mspaint.exe"},{"pname":"mspaint.exe*32"},{"pname":"mspaint.exe *32"},{"pname":"Camera.exe"},{"pname":"Camera.exe*32"},{"pname":"Camera.exe *32"},{"pname":"calc.exe"},{"pname":"calc.exe*32"},{"pname":"calc.exe *32"},{"pname":"psr.exe"},{"pname":"psr.exe*32"},{"pname":"psr.exe *32"},{"pname":"soffice.exe"},{"pname":"soffice.exe*32"},{"pname":"soffice.exe *32"},   {"pname":"soffice.bin"},{"pname":"soffice.bin*32"},{"pname":"soffice.bin *32"},{"pname":"smath.exe"},{"pname":"smath.exe*32"},{"pname":"smath.exe *32"},{"pname":"simpress.exe"},{"pname":"simpress.exe*32"},{"pname":"simpress.exe *32"},{"pname":"scalc.exe"},{"pname":"scalc.exe*32"},{"pname":"scalc.exe *32"},{"pname":"MicrosoftEdgeCP.exe"},{"pname":"MicrosoftEdgeCP.exe*32"},{"pname":"MicrosoftEdgeCP.exe *32"},{"pname":"MicrosoftEdge.exe"},{"pname":"MicrosoftEdge.exe*32"},{"pname":"MicrosoftEdge.exe *32"},{"pname":"browser_broker.exe"},{"pname":"browser_broker.exe*32"},{"pname":"browser_broker.exe *32"},{"pname":"autoscreen.exe"},{"pname":"autoscreen.exe*32"},{"pname":"autoscreen.exe *32"},{"pname":"Spotify.exe"},{"pname":"Spotify.exe*32"},{"pname":"Spotify.exe *32"},{"pname":"AIMP.exe"},{"pname":"AIMP.exe*32"},{"pname":"AIMP.exe *32"},{"pname":"vlc.exe"},{"pname":"vlc.exe*32"},{"pname":"vlc.exe *32"},{"pname":"XboxApp.exe"},{"pname":"XboxApp.exe*32"},{"pname":"XboxApp.exe *32"},{"pname":"WhatsApp.exe"},{"pname":"WhatsApp.exe*32"},{"pname":"WhatsApp.exe *32"},{"pname":"WinSnap64.exe"},{"pname":"WinSnap.exe*32"},{"pname":"WinSnap.exe *32"},{"pname":"GameBar.exe"},{"pname":"GameBarFT.exe"},{"pname":"GameBarFTServer.exe"}] }
        //_conf['pc'] = newConfpc

        if (!_conf.vc) {
          _conf.vc = { a: true, l: [], sm: true }
        }

        this.setState({
          loading: false,
          confOrig: _confOrig,
          conf: _conf,
        })

      } else {
        //TODO: mostrar error
      }
    })
  }


  checkChanges() {
    if (!global.readOnlyUser) {
      let _change = _.isEqual(this.state.confOrig, this.state.conf);
      this.setState({ change: !_change });
    }
  }
  guardarCambios() {
    //this.state.confOrig = JSON.parse(JSON.stringify(this.state.conf))
    var myHeaders = new Headers();
    let _token = localStorage.getItem("fb_jwt");
    myHeaders.append("Authorization", "Bearer " + _token);
    var formdata = new FormData();
    formdata.append("type", "A");
    formdata.append("config", JSON.stringify(this.state.conf));
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch(global.Direction_Back_panel + "/panel/config", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        this.setState({
          change: false,
          confOrig: JSON.parse(JSON.stringify(this.state.conf)),
        });
      })
      .catch((error) => console.log("error", error));

    // firebase.database().ref('configurationsA').update(this.state.conf).then(() => {
    // })
  }

  resetConfiguration() {
    //this.state.conf = JSON.parse(JSON.stringify(this.state.confOrig))
    this.setState({
      change: false,
      conf: JSON.parse(JSON.stringify(this.state.confOrig)),
    });
  }

  render() {
    return (
      <div style={{ width: "100%" }}>
        <Prompt
          when={this.state.change}
          message={(location) =>
            languages[lang].proctoringC_areYSYWTLTSWSTChanges1
          }
        />
        {this.state.loading ? (

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              marginTop: 150,
              zIndex: 99,
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <GridContainer
            direction="row"
            justifyContent="space-between"
          >
            {/* Switch Proctoring */}
            <GridItem xs={this.state.activeUsers && this.state.activeUsers.length ? 4 : 6}  >
              <h3 style={{ fontWeight: "bold", display: "inline-block" }}>{languages[lang].proctoringC_proctoring}</h3>
              <FormControlLabel
                style={{ color: "#67707c", marginLeft: 5 }}
                control={
                  <GreenSwitch
                    // color="primary"
                    checked={this.state.conf.p}
                    onChange={() => {
                      if (!global.readOnlyUser) {
                        let _confTemp = this.state.conf;
                        _confTemp.p = !this.state.conf.p;
                        this.setState({ conf: _confTemp }, this.checkChanges);
                      }
                    }}
                    value="srt"
                  />
                }
              // label={languages[lang].proctoringC_proctoring}
              />
            </GridItem>


            {/* <GridContainer>
            </GridContainer> */}
            {this.state.activeUsers && this.state.activeUsers.length ?
              <div></div>
              : null}
            {/*Boton Historial*/}
            
            <GridItem xs={4} style={{ justifyContent:"flex-end",display:"flex",flexDirection:"column",alignItems:"end",position:"relative" }}>
            {!JSON.parse(localStorage.siglocanvas)?
              <Button
                color="success"
                style={{
                  // marginRight: 10,
                  color: "#FFF",
                  backgroundColor: "#0bb4e4",
                }}
                onClick={() => {
                  this.setState({ viewActions: true });
                }}
              >
                <HistoryIcon />
                HISTORIAL
              </Button>
  :null}
              {this.state.activeUsers && this.state.activeUsers.length>0
                ?
              <div   style={{ maxWidth: 270,display:"flex",paddingTop:"15px",position:"absolute",top:'60px'  }}>

                <Paper className="divActiveUsers" elevation={3} style={{ maxWidth: 250, padding: 10,alignContent:"flex-start",alignItems:"flex-start",maxHeight:"300px",overflow:"scroll",zIndex:99 }} >
                  <Typography noWrap={true} variant="subtitle2" gutterBottom style={{paddingBottom:'5px'}}>Usuarios activos <Tooltip placement="top" title="Lista de usuarios editando en este momento."><InfoOutlinedIcon style={{color:"#ff9800"}}/></Tooltip></Typography>

                  {this.state.activeUsers.map((a, b) => (
                    <Typography noWrap={true} variant="body1" gutterBottom key={b}>{a.email}</Typography>
                  ))}

                </Paper>

              </div>
              :null
            }
              <Modal
                open={this.state.viewActions}
                onClose={() => {
                  this.setState({ viewActions: false });
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box
                  style={{
                    position: "absolute",
                    right: "0%",
                    // transform: 'translate(-50%, -50%)',
                    width: "50%",
                    height: "100%",
                    backgroundColor: "#f8f9fa",
                    // boxShadow: 24,
                    p: 4,
                  }}
                >
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      this.setState({ viewActions: false });
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                  <ActionInformation
                    field={this.state.activeTab}

                    searchStartDate={this.state.searchStartDate}
                    changeStartDate={(value) => {
                      this.setState({
                        searchStartDate: value,
                      });
                    }}
                    searchEndDate={this.state.searchEndDate}
                    changeEndDate={(value) => {
                      this.setState({
                        searchEndDate: value,
                      });
                    }}
                  ></ActionInformation>
                </Box>
              </Modal>
            </GridItem>

            {/* Botonera Guardar Cancelar */}
            {/* <GridItem xs={6} style={{ textAlign: 'end', height: 30 }}>
                    {(global.readOnlyUser) ?
                        <div/>
                      :
                        <div>
                          {(this.state.change) ?
                            <Button color="success" round style={{ marginRight: 10 }} onClick={() => {
                                this.guardarCambios()
                            }}>{languages[lang].proctoringC_save}</Button>
                          :
                            <Button color="success" disabled round style={{ marginRight: 10 }} onClick={() => {
                            }}>{languages[lang].proctoringC_save}</Button>
                          }
                          {(this.state.change) ?
                            <Button color="danger" round onClick={() => {
                              this.resetConfiguration()
                            }} >{languages[lang].proctoringC_cancel}</Button>
                          :
                            <Button color="danger" disabled round >{languages[lang].proctoringC_cancel}</Button>
                          }
                        </div>
                        }

                    </GridItem> */}

            {/* Menu */}
            <GridItem xs={12}>
              {this.state.conf.p ? (
                <NavPills
                  setActive={(x) => {
                    this.setState({ activeTab: x })
                  }}
                  color="darkVioletBiv"
                  tabs={
                    JSON.parse(localStorage.siglocanvas)?[
                      {
                        tabButton: languages[lang].proctoringC_audio,
                        tabContent: (
                          <TabAudio
                            values={this.state.conf}
                            checkChanges={() => {
                              this.checkChanges();
                            }}
                          />
                        ),
                      },
                      {
                        tabButton: languages[lang].proctoringC_examValidation,
                        tabContent: (
                          <TabValidacion
                            values={this.state.conf}
                            checkChanges={() => {
                              this.checkChanges();
                            }}
                          />
                        ),
                      },
                      {
                        tabButton: languages[lang].proctoringC_environment ,
                        tabContent: (
                          <TabAmbiente
                            values={this.state.conf}
                            checkChanges={() => {
                              this.checkChanges();
                            }}
                          />
                        ),
                      },
                    ]:[
                    {
                      tabButton: languages[lang].proctoringC_general,
                      tabContent: (
                        <TabGeneral
                          values={this.state.conf.ve}
                          onChange={(values) => {
                            if (!global.readOnlyUser) {
                              let _confTemp = this.state.conf;
                              _confTemp.ve = values;
                              this.setState(
                                { conf: _confTemp },
                                this.checkChanges
                              );
                            }
                          }}
                        />
                      ),
                    },
                    {
                      tabButton: languages[lang].proctoringC_picture,
                      tabContent: (
                        <TabImagen
                          values={this.state.conf}
                          checkChanges={(values) => {
                            this.checkChanges();
                          }}
                        />
                      ),
                    },
                    {
                      tabButton: languages[lang].proctoringC_audio,
                      tabContent: (
                        <TabAudio
                          values={this.state.conf}
                          checkChanges={() => {
                            this.checkChanges();
                          }}
                        />
                      ),
                    },
                    {
                      tabButton: languages[lang].proctoringC_examValidation,
                      tabContent: (
                        <TabValidacion
                          values={this.state.conf}
                          checkChanges={() => {
                            this.checkChanges();
                          }}
                        />
                      ),
                    },
                    {
                      tabButton: languages[lang].proctoringC_environment ,
                      tabContent: (
                        <TabAmbiente
                          values={this.state.conf}
                          checkChanges={() => {
                            this.checkChanges();
                          }}
                        />
                      ),
                    },
                  ]}
                />
              ) : (
                <div
                  style={{
                    height: 300,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <h3>{languages[lang].proctoringC_proctoringOff}</h3>
                  <h4>{languages[lang].proctoringC_toAccesTSYSAIt}</h4>
                </div>
              )}
            </GridItem>

            {/* Botonera Guardar Cancelar */}
            <GridItem xs={12} style={{ textAlign: "end", height: 30, position: "fixed", bottom: 30, right: 5 }}>
              {global.readOnlyUser ? (
                <div />
              ) : (
                <div>

                  <Button
                    disabled={!this.state.change}
                    onClick={() => {
                      this.guardarCambios();
                    }}
                    style={{
                      marginRight: 10,
                      color: "#FFF",
                      backgroundColor: "#0bb4e4",
                      borderColor: "#0bb4e4",
                    }}
                  >
                    {languages[lang].proctoringC_save}
                  </Button>

                  <Button
                    disabled={!this.state.change}
                    style={{
                      marginRight: 10,
                      color: "#0bb4e4",
                      backgroundColor: "#FFF",
                      borderColor: "#0bb4e4",
                    }}
                    onClick={() => {
                      this.resetConfiguration();
                    }}
                  >
                    {languages[lang].proctoringC_cancel}
                  </Button>
                </div>
              )}
            </GridItem>
          </GridContainer>
        )}
      </div>
    );
  }
}

export default withStyles(sweetAlertStyle)(BivConfigurationProctoring);
